<template>
    <div class="u-switch" :class="{ active: value }" @click="onClick">
        <div class="icon-bl">
            <i v-if="value" class="el-icon-moon"></i>
            <i v-else class="el-icon-sunny"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick() {
            this.$emit("input", !this.value)
            this.$emit("change", !this.value)
        }
    },
}
</script>

<style lang="scss" scoped>
.u-switch {
    cursor: pointer;
    display: inline-block;
    width: 40px;
    height: 22px;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 15px;
    background: #f5f5f5;
    transition: all .5s;
    text-align: left;
    line-height: 10px;

    &.active {
        text-align: right;
        background: rgba(255, 255, 255, .2);
        border-color: rgba(255, 255, 255, .3);

        .icon-bl {
            background: #111;
            color: #fff;
        }
    }

    .icon-bl {
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 100%;
        background: #fff;
        text-align: center;
    }

}
</style>